import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../../styles/GlobalStyle.css'
import { db } from '../../firebase/Firebase'
import ColType from '../.././Types'
//import IEPDrafts from './IEPDrafts'
import {
  flattenDoc, getIDFromURL, getQueryStringParam
} from '../.././Util'
//import PersonAvatar from '../../customcomponents/PersonAvatar'
import { Layout, Button, Icon, Select, Form, message } from 'antd'
import DraftStepContainer from './DraftStepContainer'
const { Content } = Layout
const Option = Select.Option
const FormItem = Form.Item

const errorMessage = (description) => {
  message.error(description)
}

class TeacherAddIEPGoalAccommodation extends Component {
  state = {
    teacherId: null,
    studentId: null,
    teacher: null,
    student: null,
    iepDraft: null,
    students: [],
    studentDict: {},
    iepDrafts: [],
    presentLevels: {},
    selectedObj: {
      instructionBarrier: null,
      engagementBarrier: null,
      organizationBarrier: null,
      PSI: {
        instructionBarrier: [
          "No presentation strategies needed",
          'Create consistent daily class routines',
          'Break the lesson into smaller chunks',
          'Listen to an audio version while reading or instead of reading',
          'Provide a hook related to personal interests for lengthy assignments',
          'Talk slowly when giving oral directions',
          'Give simple written directions',
        ],
        engagementBarrier: [
          "No engagement strategies needed",
          'Provide frequent checks for understanding',
          'Give extra verbal response time for answering questions',
          'Provide familiar or high-interest text',
          'Give time for skimming and scanning',
          'Give ample time for error correction',
          'Provide visual cues',
          'Use of a highlighter or sticky notes',
          'Supply notes or lesson outlines'
        ],
        organizationBarrier: [
          "No expression strategies needed",
          'Provide alternatives for lengthy handwritten assignments',
          'Show an exemplar before the start of the task',
          'Shorten assignments',
          'Give access to tools that support processing (calculator/spell check)',
          'Provide extended time to complete assignments',
          'Provide a rubric about how the task will be graded'
        ],
      },
      WMI: {
        instructionBarrier: [
          "No presentation strategies needed",
          'Preview the lesson',
          'Connect new concepts to prior knowledge',
          'Use visuals to support information like anchor charts, diagrams, or pictures',
          'Give brief, concise directions',
          'Provide graphic organizers',
          'Repeat instructions',
          'Give picture prompts',
        ],
        engagementBarrier: [
          "No engagement strategies needed",
          "Chunk information",
          'Paraphrase information',
          'Provide immediate positive feedback for effort and persistence',
          'Minimize threats and distractions',
          'Provide multiple opportunities for practice in short sessions',
          'Create safe environment for asking for help',
          'Give visual cues to maintain attention',
          'Ask student to restate the goals',
          'Highlight relevant information',
        ],
        organizationBarrier: [
          "No expression strategies needed",
          'Provide fill in the blank graphic organizers',
          'Supply checklists and guides',
          'Provide opportunities for repeating tasks',
          'Use specific routines and procedures',
          'Create consistent daily class routines',
          'Provide choices for expressing understanding',
          'Provide visuals or manipulatives to accompany instruction',
          'Allow access to tools that reduce memory load (calculator/spell check)',
          'Provide sentence starters',
          'Provide models and examples',
        ],
      },
      VCI: {
        instructionBarrier: [
          "No presentation strategies needed",
          'Preteach new vocabulary',
          'Highlight new vocabulary and major concepts',
          'Connect new concepts to prior knowledge',
          'Provide visuals or graphics to support new concepts',
          'Proximity seating',
          'Incorporate interests when teaching new concepts',
          'Use of graphic organizers to teach new concepts',
        ],
        engagementBarrier: [
          "No engagement strategies needed",
          'Incorporate interests when teaching new concepts',
          'Frequently check in with student to ensure comprehension',
          'Provide a reward system',
          'Provide a fill in the blank outline and/or cloze notes',
          'Paraphrase what has been taught periodically during lesson'
        ],
        organizationBarrier: [
          "No expression strategies needed",
          'Provide a concept map',
          'Provide a word bank',
          'Use anchor charts or word walls',
          'Offer options to written assignments',
          'Provide sentence starters'
        ],
      },
      VSI: {
        instructionBarrier: [
          "No presentation strategies needed",
          'Provide clear and concise oral instructions',
          'Provide time for asking questions for clarification',
          'Pair oral instructions with visual/concrete manipulatives',
          'Check for level of understanding',
        ],
        engagementBarrier: [
          "No engagement strategies needed",
          'Build in time to summarize the important information from each lesson',
          'Provide uncluttered handouts with few or no nonessential images',
          'Provide a highlighter for key information while reading',
          'Clearly space words and problems on a page',
        ],
        organizationBarrier: [
          "No expression strategies needed",
          'Provide copies of notes',
          'Use assistive technology',
          'Offer a choice of assessments/assignments',
          'Provide a lot of space for answers'
        ],
      },
      FRI: {
        instructionBarrier: [
          "No presentation strategies needed",
          'Provide teacher think alouds when teaching new concepts',
          'Supply an outline of lessons',
          'Use numerous examples to explain new concepts',
          'Preview of tasks and expectations',
          'Provide procedural checklists',
          'Clearly state goals and objectives'
        ],
        engagementBarrier: [
          "No engagement strategies needed",
          'Use graphic organizers to provide a summary of information',
          'Give analogies that are relatable',
          'Provide time for student to explain their work',
          'Designate a peer buddy to collaborate on task',
          'Ask clear and concise questions'
        ],
        organizationBarrier: [
          "No expression strategies needed",
          'Provide time to verbalize thought process',
          'Show exemplars',
          'Provide manipluatives',
          'Highlighting relevant information',
          'Post anchor charts',
          'Post concept maps'
        ],
      },
    },
    barriersSelected: 0,
    requiredBarrierNum: 0,
    tabKey: '1',
    stepNum: 6,
    iepDraftMounted: false,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.search !== nextProps.location.search) {
      if (this.props.form) this.props.form.resetFields()
      this.componentDidMount()
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    var teacherId = getIDFromURL(window.location)
    var studentId = getQueryStringParam('student')
    var draftId = getQueryStringParam('draft')
    console.log(teacherId, studentId, draftId)

    this.setState({
      teacherId: teacherId,
      studentId: studentId,
      draftId: draftId,
      tabKey: '1',
    })

    if (draftId) {
      db.collection(ColType.iepDrafts)
        .doc(draftId)
        .get()
        .then((doc) => {
          console.log(doc.id, '=>', doc.data())
          var iepDraft = flattenDoc(doc)
          var requiredBarrierNum = 0
          if (iepDraft.level === '70 and below') requiredBarrierNum = 3
          else if (iepDraft.level === '70-79') requiredBarrierNum = 2
          else if (iepDraft.level === '80 and above') requiredBarrierNum = 1
          if (iepDraft.hasOwnProperty('accommodations')) {
            var selectedObj = this.state.selectedObj
            var barriersSelected = 0
            selectedObj['instructionBarrier'] = iepDraft.accommodations['instructionBarrier']
            selectedObj['engagementBarrier'] = iepDraft.accommodations['engagementBarrier']
            selectedObj['organizationBarrier'] = iepDraft.accommodations['organizationBarrier']
            if (selectedObj['instructionBarrier'] !== null) {
              barriersSelected += 1
            }
            if (selectedObj['engagementBarrier'] !== null) {
              barriersSelected += 1
            }
            if (selectedObj['organizationBarrier'] !== null) {
              barriersSelected += 1
            }
            this.setState({
              selectedObj,
              barriersSelected,
            })
          }

          this.setState({
            iepDraft: iepDraft,
            requiredBarrierNum: requiredBarrierNum,
            iepDraftMounted: true,
          }, () => {
            var iepDraft = this.state.iepDraft
            if (iepDraft) {
              this.props.form.setFieldsValue(iepDraft.accommodations)
            }
          })
        })
    }

    db.collection(ColType.teacher)
      .doc(teacherId)
      .get()
      .then((doc) => {
        var teacher = flattenDoc(doc)

        db.collection(ColType.student)
          .doc(studentId)
          .get()
          .then((doc) => {
            var student = flattenDoc(doc)
            this.setState({
              teacher: teacher,
              student: student,
            })
          })
      })

    db.collection(ColType.student)
      .where('teacherId', '==', teacherId)
      .get()
      .then((querySnapshot) => {
        var students = []
        var studentDict = {}
        querySnapshot.forEach((doc) => {
          //console.log(doc.id, ' => ', doc.data())
          var student = flattenDoc(doc)
          students.push(student)
          studentDict[student.id] = student
        })

        this.setState({
          students: students,
          studentDict: studentDict,
        })
      })
  }

  // add a new event to the teacher's events
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.state.barriersSelected < this.state.requiredBarrierNum) {
          errorMessage('Please select ' + this.state.requiredBarrierNum + ' ' + (this.state.requiredBarrierNum === 1 ? 'strategy.' : 'strategies.'))
          return
        }

        console.log('Received values from form', values)
        // if only 1 or 2 of these is required the nonselected values
        // can be undefined, so here we check if any are undefined
        // then delete the value as firebase cannot have undefined values.
        if (!values.instructionBarrier) delete values.instructionBarrier
        if (!values.engagementBarrier) delete values.engagementBarrier
        if (!values.organizationBarrier) delete values.organizationBarrier

        var newState = this.state.iepDraft
        newState.accommodations = values
        newState.step = { stepNum: this.state.stepNum + 1, path: 'confirm' }

        db.collection(ColType.iepDrafts)
          .doc(this.state.draftId)
          .set(newState, { merge: true })
          .then(() => {
            this.props.history.push(
              {
                pathname: '/teacher/add-goal-confirm/' +
                  this.state.teacherId + '?student=' +
                  this.state.studentId +
                  '&draft=' + this.state.draftId,
                state: newState, // pass state to confirm page
              }
            )
          })
      }
    })
  }

  tabChange = (activeKey) => {
    this.setState({ tabKey: activeKey })
  }

  selectChange = (value, option, sectionKey) => {
    //console.log(value, option, sectionKey)
    var selectedObj = this.state.selectedObj
    selectedObj[sectionKey] = value

    var barriersSelected = 0
    if (selectedObj['instructionBarrier']) {
      barriersSelected += 1
    }
    if (selectedObj['engagementBarrier']) {
      barriersSelected += 1
    }
    if (selectedObj['organizationBarrier']) {
      barriersSelected += 1
    }

    this.setState({
      barriersSelected: barriersSelected,
      selectedObj: selectedObj,
    })
  }

  unselectBarrier = (e, sectionKey) => {
    var selectedObj = this.state.selectedObj
    selectedObj[sectionKey] = null

    var barriersSelected = 0
    if (selectedObj['instructionBarrier'] !== null) {
      barriersSelected += 1
    }
    if (selectedObj['engagementBarrier'] !== null) {
      barriersSelected += 1
    }
    if (selectedObj['organizationBarrier'] !== null) {
      barriersSelected += 1
    }

    this.props.form.setFieldsValue({ [sectionKey]: null })

    this.setState({
      barriersSelected: barriersSelected,
      selectedObj: selectedObj,
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    }

    return (
      <div>
        <Layout className="content layout-header-mt">
          <Layout>
            <Content className="min-w-1120">
              <div>
                <DraftStepContainer
                  teacherBaseProps={this.props.teacherBaseProps}
                  dataLoaded={this.state.iepDraftMounted}
                >
                  <div>

                    {this.state.iepDraftMounted ?
                      <div>
                        <div className="w-800 m-lr-auto background-fff br-15">
                          <div className='p-4 bkg-purple br-15'>
                            <div className='flex flex-v-center w-100'>
                              <div>
                                {this.props.teacherBaseProps &&
                                  this.props.teacherBaseProps.studentDict &&
                                  this.props.teacherBaseProps.studentDict
                                    .hasOwnProperty(this.state.studentId)
                                  ?
                                  <div className="flex flex-v-center mb-0 font-24">
                                    <div>
                                      <div className='font-20 font-fff'>
                                        IEP Draft for {this.props.teacherBaseProps
                                          .studentDict[this.state.studentId].firstName + ' ' +
                                          this.props.teacherBaseProps
                                            .studentDict[this.state.studentId].lastName}
                                      </div>
                                      <h1 className="font-40 mb-0 font-fff font-bold">
                                        Accommodations
                                      </h1>
                                    </div>
                                  </div>
                                  : ''}
                              </div>
                              <img src="/draft-icons/7.png" alt='draft-iep' width={250} className='ml-auto' />
                            </div>
                          </div>
                          <div className='p-4'>
                            <h3 className="mb-3 font-20">
                              Select connection strategies to remove barriers and to help
                              {this.props.teacherBaseProps &&
                                this.props.teacherBaseProps.studentDict &&
                                this.props.teacherBaseProps.studentDict
                                  .hasOwnProperty(this.state.studentId)
                                ?
                                (' ' + this.props.teacherBaseProps
                                  .studentDict[this.state.studentId].firstName + ' ') :
                                ' '}
                              access the general education curriculum.
                            </h3>
                            <h2 className="font-bold mb-1 font-24"
                            >Choose {(this.state.requiredBarrierNum < 3 ? ' at least ' : '') +
                              this.state.requiredBarrierNum + ' ' +
                              (this.state.requiredBarrierNum === 1 ? 'strategy' : 'strategies')}</h2>
                            <h3 className="mb-4 font-20">
                              {this.state.barriersSelected} /
                              {' ' + this.state.requiredBarrierNum + ' ' +
                                (this.state.requiredBarrierNum === 1 ? 'strategy' : 'strategies')} chosen
                            </h3>
                            <Form onSubmit={this.handleSubmit}
                              className="block-label-form">


                              <FormItem {...formItemLayout}
                                label={<div>
                                  <div className='font-20 font-bold'>
                                    Presentation Strategies
                                  </div>
                                  <div className='font-16 font-normal'>
                                    Strategies to represent content in multiple ways to enhance understanding. Universal Design for Learning calls it multiple means of representation or the "what" of learning.
                                  </div>
                                </div>}>
                                {getFieldDecorator('instructionBarrier', {
                                  rules: [{ required: false, message: 'Select an assessment.' }],
                                })(
                                  <Select
                                    size={'large'}
                                    placeholder="Select..."
                                    allowClear={true}
                                    onChange={
                                      (value, option) =>
                                        this.selectChange(value, option, 'instructionBarrier')
                                    }
                                  >
                                    {this.state.iepDraft.category &&
                                      this.state.selectedObj[this.state.iepDraft.category]
                                        .instructionBarrier
                                        .map((instructionValue, index) => {
                                          return <Option
                                            value={instructionValue}
                                            key={instructionValue}
                                          >
                                            {instructionValue}
                                          </Option>
                                        })
                                    }
                                  </Select>
                                )}
                              </FormItem>

                              <FormItem {...formItemLayout}
                                label={<div>
                                  <div className='font-20 font-bold'>
                                    Engagement Strategies
                                  </div>
                                  <div className='font-16 font-normal'>
                                    Strategies to increase student motivation and excitement about learning. Universal Design for Learning calls it multiple means of engagement or the "why" of learning.
                                  </div>
                                </div>}>
                                {getFieldDecorator('engagementBarrier', {
                                  rules: [{ required: false, message: 'Select an assessment.' }],
                                })(
                                  <Select
                                    size={'large'}
                                    placeholder="Select..."
                                    allowClear={true}
                                    onChange={
                                      (value, option) =>
                                        this.selectChange(value, option, 'engagementBarrier')
                                    }
                                  >
                                    {this.state.iepDraft.category &&
                                      this.state.selectedObj[this.state.iepDraft.category]
                                        .engagementBarrier
                                        .map((engagementValue, index) => {
                                          return <Option
                                            value={engagementValue}
                                            key={engagementValue}
                                          >
                                            {engagementValue}
                                          </Option>
                                        })
                                    }
                                  </Select>
                                )}
                              </FormItem>

                              <FormItem {...formItemLayout}
                                label={<div>
                                  <div className='font-20 font-bold'>
                                    Expression Strategies
                                  </div>
                                  <div className='font-16 font-normal'>
                                    Strategies to provide different ways for students to express what they learn. Universal Design for Learning calls it multiple means of expression or the "how" of learning.
                                  </div>
                                </div>}>
                                {getFieldDecorator('organizationBarrier', {
                                  rules: [{ required: false, message: 'Select an assessment.' }],
                                })(
                                  <Select
                                    size={'large'}
                                    placeholder="Select..."
                                    allowClear={true}
                                    onChange={
                                      (value, option) =>
                                        this.selectChange(value, option, 'organizationBarrier')
                                    }
                                  >
                                    {this.state.iepDraft.category &&
                                      this.state.selectedObj[this.state.iepDraft.category]
                                        .organizationBarrier
                                        .map((organizationValue, index) => {
                                          return <Option
                                            value={organizationValue}
                                            key={organizationValue}
                                          >
                                            {organizationValue}
                                          </Option>
                                        })
                                    }
                                  </Select>
                                )}
                              </FormItem>

                              <div className="mb-0 mt-4 pt-2 flex flex-v-center w-100">
                                <Link
                                  to={'/teacher/add-goal-service/' +
                                    this.state.teacherId + '?student=' +
                                    this.state.studentId +
                                    '&draft=' + this.state.draftId}
                                  className="font-18"
                                >
                                  <span className="left-hover-parent text-cyan">
                                    <Icon type="arrow-left" className="mr-1 left-hover-child" />
                                    <span>Previous Step</span>
                                  </span>
                                </Link>
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  className="lg-btn ml-auto"
                                >
                                  Continue
                                </Button>
                              </div>
                            </Form>
                          </div>
                        </div>
                      </div>
                      : ''}

                  </div>
                </DraftStepContainer>
              </div>

            </Content>
          </Layout>
        </Layout>
      </div>
    )
  }
}

export default Form.create()(TeacherAddIEPGoalAccommodation)